<template>
  <div class="page-veteran wrapper">
    <el-row type="flex" class="content-module top-module">
      <div class="content-left">
        <img :src="info.img" alt="宣传图" class="img">
        <p class="img-sub-title" v-html="info.title" />
      </div>
      <div class="content-right">
        <p class="content-title">军转培训介绍</p>
        <p class="content-text" v-html="info.content" />
      </div>
    </el-row>
    <div class="content-module info-list margin-top_24">
      <el-row type="flex" align="middle" class="section-title">
        <span class="text">培训动态</span>
        <div class="nav-button" @click="toList">查看更多 >></div>
      </el-row>
      <ul class="list">
        <li v-for="item of list" :key="item.id" class="list-item" @click="toDetail(item.id)">{{ item.name }}</li>
      </ul>
    </div>
    <!-- <el-row type="flex" justify="space-between" class="showcase margin-top_24">
      <img src="" alt="" class="img">
      <img src="" alt="" class="img">
    </el-row> -->
    <Cooperation />
  </div>
</template>

<script>
import { getVeteranByType, getVeteranListByType } from '@/api/veteran'
import Cooperation from './component/cooperation.vue'

export default {
  name: 'Veteran',

  components: { Cooperation },
  data() {
    return {
      info: {},
      list: []
    }
  },
  created() {
    this.handleGetVeteranByType(1)
    this.handleGetVeteranListByType(2)
  },
  methods: {
    toList () {
      this.$router.push({
        path: '/veteranList',
        query: {}
      })
    },
    toDetail (id) {
      this.$router.push({
        path: '/veteranDetail',
        query: { id, rePath: '/veteran', reLabel: '退役军人培训' }
      })
    },
    handleGetVeteranByType(type) {
      getVeteranByType({ type }).then(({ code, data }) => {
        if (code === 0) {
          this.info = data
        }
      })
    },
    handleGetVeteranListByType(type) {
      const params = {
        limit: 6,
        page: 1,
        type
      }
      getVeteranListByType(params).then(({ code, data }) => {
        if (code === 0) {
          this.list = data.records
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-veteran {
  padding-top: 24px;
  padding-bottom: 56px;
  .section-title {
    .nav-button {
      margin-left: auto;
      font-size: 14px;
      color: #0861D5;
      cursor: pointer;
    }
  }
}
.top-module {
  .content-left {
    width: 836px;
    height: 504px;
    position: relative;
    .img {
      width: 100%;
      height: 458px;
    }
    .img-sub-title {
      width: 836px;
      height: 46px;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #0861D5;
      line-height: 46px;
      text-align: center;
      font-size: 16px;
      color: #FFFFFF;
      overflow: hidden;
    }
  }
  .content-right {
    flex: 1;
    width: 0;
    height: 504px;
    box-sizing: border-box;
    padding: 32px;
    background: linear-gradient( 180deg, #DFEDFF 0%, #FFFFFF 100%, #FFFFFF 100%);
    .content-title {
      margin-bottom: 8px;
      position: relative;
      line-height: 28px;
      font-weight: 600;
      font-size: 20px;
      color: #2F2F2F;
      &::after {
        display: block;
        content: '';
        width: 100%;
        height: 4px;
        background: linear-gradient( 90deg, rgba(255,255,255,0) 0%, #0861D5 48%, rgba(255,255,255,0) 100%), #0861D5;
        position: absolute;
        left: 0;
        bottom: -8px;
      }
    }
    .content-text {
      max-height: 380px;
      overflow-y: auto;
      padding-top: 24px;
      line-height: 32px;
      font-size: 16px;
      color: #2F2F2F;
      ::v-deep video {
        max-width: 100%;
      }
    }
  }
}
.info-list {
  box-sizing: border-box;
  padding: 24px;
  background: #FFFFFF;
  .list {
    width: 100%;
    padding-top: 16px;
    .list-item {
      padding: 16px 0;
      line-height: 22px;
      font-size: 16px;
      color: #2F2F2F;
      cursor: pointer;
      & + .list-item {
        border-top: 1px dashed #D9D9D9;
      }
    }
  }
}
.showcase {
  .img {
    width: 640px;
    height: 120px;
  }
}
</style>
